import { ExternalDocumentationElement } from '@swagger-api/apidom-ns-openapi-3-0';

/**
 * @public
 */
class ExternalDocumentation extends ExternalDocumentationElement {}
export default ExternalDocumentation;